module.exports = __webpack_public_path__ + "img/image-empty.139e2091.svg";